module.exports = __webpack_public_path__ + "img/bigscoot-ui.4fcbd1d3.png";